import { Card, Descriptions, Tag, Space, Button, Typography } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { env } from '@/utils/env';

export function SettingsPage() {
  const profile = useAuthStore((s) => s.profile);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  const handleLogout = () => {
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <Card title="账号设置">
      <Descriptions column={1} size="small">
        <Descriptions.Item label="账号">
          {profile?.username || '-'}
        </Descriptions.Item>
        <Descriptions.Item label="显示名">
          {profile?.display_name || '-'}
        </Descriptions.Item>
        <Descriptions.Item label="角色">
          {profile?.role ? <Tag color="purple">{profile.role}</Tag> : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="作用域">
          {profile?.scope || '-'}
        </Descriptions.Item>
        <Descriptions.Item label="API base">
          <Typography.Text code>{env.apiBase || '(vite proxy)'}</Typography.Text>
        </Descriptions.Item>
      </Descriptions>
      <Space style={{ marginTop: 16 }}>
        <Button danger icon={<LogoutOutlined />} onClick={handleLogout}>
          退出登录
        </Button>
      </Space>
    </Card>
  );
}
